<div class="cx-wizard-step" [hidden]="!active" *ngIf="!skipped">
	<ng-content></ng-content>
</div>